"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapNumericOnEvent = exports.wrapNumericValue = void 0;
const wrapNumericValue = (value) => {
    return value !== null && value !== void 0 ? value : '';
};
exports.wrapNumericValue = wrapNumericValue;
const wrapNumericOnEvent = (eventCallback) => (event) => {
    const value = event.target.value !== '' ? event.target.value : undefined;
    eventCallback({ ...event, target: { ...event.target, value } });
};
exports.wrapNumericOnEvent = wrapNumericOnEvent;
//# sourceMappingURL=utils.js.map